import request from '@/util/request';
import qs from 'qs';

export const getPageListApi = (params, options) =>
  request.get('/api/nursing/elderlyFiles/page', Object.assign({}, options, { params }));

export const getDetailApi = (params, options) =>
  request.get('/api/nursing/elderlyFiles/detail', Object.assign({}, options, { params }));

export const addApi = (params, options) =>
  request.post('/api/nursing/elderlyFiles/save', params, options, {
    ContentType: 'application/json',
  });

export const updateApi = (params, options) =>
  request.post('/api/nursing/elderlyFiles/update', params, options, {
    ContentType: 'application/json',
  });

export const removeApi = (params, options) =>
  request.post('/api/nursing/elderlyFiles/remove', qs.stringify(params), options);

export const cancelApi = (params, options) =>
  request.post('/api/nursing/elderlyFiles/cancel', params, options, {
    ContentType: 'application/json',
  });

export const startApi = (params, options) =>
  request.post('/api/nursing/elderlyFiles/startWork', params, options, {
    ContentType: 'application/json',
  });

export const finishApi = (params, options) =>
  request.post('/api/nursing/elderlyFiles/endWork', params, options, {
    ContentType: 'application/json',
  });

export const getElderListApi = (params, options) =>
  request.get(
    `/api/nursing/basicInfor/basicInfoList/${params.nursinghomeId}`,
    Object.assign({}, options, { params: {} })
  );
